import { h } from 'hastscript';
import { visit } from 'unist-util-visit';
import remarkAdmonition, {
  admonitionTag,
  isValidAdmonitionTag,
} from './remark-directive-extension-lib/remark-admonition';
import remarkHighlight from './remark-directive-extension-lib/remark-highlight';

export default function remarkDirectiveExtension(locale: string) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (tree: any) => {
    visit(tree, (node) => {
      try {
        if (node.type === 'containerDirective') {
          const sourceName = (node.name as string).trim().split(' ');
          const nodeName = sourceName.shift() as string;

          // eslint-disable-next-line no-param-reassign
          const data = node.data || (node.data = {});
          const hast = h(nodeName, node.attributes);
          if (!hast.properties) hast.properties = {};

          if (isValidAdmonitionTag(nodeName)) {
            remarkAdmonition(node, hast, locale);
          }
          if (nodeName === 'highlight') {
            remarkHighlight(node, hast);
          }

          data.hProperties = hast.properties;
        }
      } catch (error) {
        //
      }
    });
  };
}
